<template>
  <div id="app">
    <router-view/>
    <GlobalLayer></GlobalLayer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import Layout from 'components/layout/Layout'
import GlobalLayer from 'components/common/globalLayer'

import utils from './views/article/src/utils/index'

export default {
  name: 'app',
  components: {
    // Layout,
    GlobalLayer
  },
  data () {
    return {
      entryUrl: ''
    }
  },
  computed: {
    ...mapState([
      'loginUser',
      'isMobile'
    ])
  },
  watch: {
    '$route': {
      handler: function (val, oldVal) {
        this.timer = setTimeout(() => {
          this.initWxConfig()
        }, 300)
      }
    }
  },
  created () {
    // 微信分享用
    this.entryUrl = window.location.href
    this.initWxConfig()
    this.getSigninInfo()
    this.setMoblie(this.checkMobile())
    this.getNowTime()
    // this.getLayoutNav()
    this.getPhoneList()
  },
  mounted () {
    window.onresize = function () {
      this.setMoblie(this.checkMobile())
    }.bind(this)
    // 如果是在 苹果浏览器内 给body 添加 class 做兼容处理
    if (utils.isIOS()) {
      document.body.classList.add('ios')
    }
    utils.GA('create')
  },
  methods: {
    ...mapActions([
      'getNowTime',
      'getSigninInfo',
      // 'getLayoutNav',
      'getPhoneList'
    ]),
    ...mapMutations({
      setMoblie: 'CHECK_MOBILE'
    }),
    checkMobile () {
      const ua = navigator.userAgent.toLowerCase()
      return (/iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua)) || document.body.clientWidth <= 768
    },
    // 初始化微信配置
    initWxConfig: function () {}
  }
}
</script>

<style lang="scss">
@import './style/app.sass';
@import './style/iconfont/iconfont.css';

@import '~vue2-scrollbar/dist/style/vue2-scrollbar.css';
@import '~@geekbang/geek.ui/src/assets/css/reset';
@import './assets/css/custom.loading';
@import './assets/css/custom.button';
@import './assets/css/custom.dialog';
@import './assets/css/custom.popup';
@import './assets/css/custom.form';
@import './assets/css/custom.message';
@import './assets/css/custom.paging';
@import './assets/css/base';

@import './assets/css/article';
@import './assets/css/article.preview';

@font-face {
  font-family: 'google-word';
  src: url('./assets/font/GoogleSans-Medium.ttf') format('truetype');
}

* {
  margin: 0;
  padding: 0;
  // font-family: PingFang SC
  font-family: 'google-word', PingFang SC !important;
}

html {
  background: #FFF;
  min-height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  min-height: 100vh;
  background: #FFF;
}
body.fixed {
  overflow: hidden;
  position: fixed;
  width: 100vw; height: 100vh;
}
i {
  font-style: normal;
}
a {
  word-wrap: break-word;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: $blue;
}
#app {
  width: 100vw;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-in-top-enter-active,
.slide-in-top-leave-active,
.slide-in-right-enter-active,
.slide-in-right-leave-active {
  transition: all 0.3s ease;
}
.slide-in-top-enter,
.slide-in-top-leave-to {
  transform: translateY(5px);
  opacity: 0;
}
</style>
